<template>
  <div>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Disable Payment
          <small>Disable a payment on specific time</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
          <li>Operation Tools</li>
          <li class="active">Disable Payment</li>
        </ol>
      </section>

      <section class="content">
        <div class="box">
          <div class="box-header">
            <a class="btn btn-success pull-right" @click.prevent="add">
              Add New Disable Payment
            </a>
          </div>

          <div class="box-body">
            <div class="table-responsive">
              <table id="table" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Payment Method</th>
                    <th class="text-center">Start Date</th>
                    <th class="text-center">End Date</th>
                    <th class="text-center">Time Range</th>
                    <th>Days</th>
                    <th class="text-center">Media</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Actions(s)</th>
                  </tr>
                </thead>

                <tbody v-if="!setups" key="empty">
                  <tr>
                    <td colspan="8">
                      No record
                    </td>
                  </tr>
                </tbody>

                <tbody v-else key="finish">
                  <tr v-for="(item, index) in setups" :key="index">
                    <td>{{ getMethodName(item.payment_method) }}</td>
                    <td class="text-center">{{ parseDate(item.start_date) }}</td>
                    <td class="text-center">{{ parseDate(item.end_date) }}</td>
                    <td class="text-center">{{ item.start_end_time[0].start }} - {{ item.start_end_time[0].end }}</td>

                    <td>
                      <span v-for="(day, dayIndex) in item.days"
                        :key="dayIndex">
                        {{ parseDay(day) }},
                      </span>
                    </td>

                    <td class="text-center">
                      <span class="label"
                        v-for="(media, mediaIndex) in item.media"
                        :class="media"
                        :key="mediaIndex">
                        <i class="fa fa-fw" :class="parseMedia(media)"></i>
                      </span>
                    </td>

                    <td class="text-center">
                      <button class="btn btn-xs"
                        :class="{
                          'btn-success': item.is_enabled == 1,
                          'btn-default': item.is_enabled == 0,
                        }">
                        <template v-if="item.is_enabled == 0">Disabled</template>
                        <template v-else>Enabled</template>
                      </button>
                    </td>

                    <td class="text-center">
                      <a class="btn btn-primary btn-xs"
                        @click="edit(item.id)">
                        Edit
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="box-footer">
            <Pagination
              :pagination="pagination"
              @goto-page="changePage" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      setups: [],
      pagination: {},
    };
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page || null;

      const params = {
        page: page || pageQuery,
      };

      this.axios.get('/payments/setup', { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            return;
          }

          this.setups = data;
          this.pagination = meta.pagination;
        });

      if (page) {
        window.history.pushState(`Payment Setup page: ${page}`, null, `/payment-setups?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    getMethodName(method) {
      return (method) ? method[0].name : '-';
    },

    add() {
      this.$router.push('/payment-setups/create');
    },

    edit(value = null) {
      this.$router.push({
        name: 'payment-setups-edit',
        params: {
          id: value,
          page: 'edit',
        },
      });
    },

    parseMedia(media) {
      if (!media) return '';

      if (media === 'web') {
        return 'fa-desktop';
      }

      if (media === 'ios') {
        return 'fa-apple';
      }

      return 'fa-android';
    },

    parseDate(date) {
      return moment(date).format('DD MMMM YYYY');
    },

    parseDay(day) {
      if (day === 1) return 'Mon';
      if (day === 2) return 'Tue';
      if (day === 3) return 'Wed';
      if (day === 4) return 'Thu';
      if (day === 5) return 'Fri';
      if (day === 6) return 'Sat';
      if (day === 7) return 'Sun';
      return '';
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
  .label {
    &.label-block {
      display: block;
      padding: 0.5rem;
    }

    &.web {
      background-color: #1976d2;
      margin: 0 0.125rem;
    }

    &.ios {
      background-color: #e91e63;
      margin: 0 0.125rem;
    }

    &.android {
      background-color: #4caf50;
      margin: 0 0.125rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/setups/Main.vue